import { config } from '@static/js/env.config';
import { useState } from 'react';

interface ShowDevAlertProps {
  message: string;
  redirectPath: string;
}

export const ShowDevAlert = ({ message, redirectPath }: ShowDevAlertProps) => {
  const [shouldShowDevAlert, setShouldShowDevAlert] = useState(config.joyEnvironment === 'development');

  if (shouldShowDevAlert) {
    if (!window.confirm(message)) {
      window.location.href = `https://withjoy.com/${redirectPath}`;
    }
    setShouldShowDevAlert(false);
  }

  return null;
};
